import React, { useEffect } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import TagManager from "react-gtm-module";
import { withTranslation } from "react-i18next";

import {
  loadRestaurant,
  setLanguageId,
  setUiLanguageId,
} from "../redux/actions/baseActions";

import "../assets/sass/deliveryTypeLayout.scss";
import DeliveryTypeSwitcher from "./components/DeliveryTypeSwitcher";
import ShortFooter from "./components/ShortFooter";
import { getImageUrl } from "../api/iposApi";
import IPosModal from "../IPosModal";
import HeaderNew from "./components/HeaderNew";

function DeliveryTypeLayout({
  loadRestaurant,
  branchInfo,
  t,
  setLanguageId,
  setUiLanguageId,
}) {
  const PLAY_AD_VIDEO_TIMEOUT_SEC = 30;
  const { branchId } = useParams();
  const history = useHistory();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const langParam = searchParams.get("lang");
  const hasAdvertisement =
    branchInfo && branchInfo.VideoPaths && branchInfo.VideoPaths.length > 0;
  let timeout = undefined;

  useEffect(() => {
    setLanguageId(langParam === "en" ? 1 : 2);
    setUiLanguageId(langParam === "en" ? 1 : 2);
  }, [langParam]);

  function resetTimer() {
    if (timeout) {
      clearTimeout(timeout);
    }

    timeout = setTimeout(function () {
      removeAdvertisementEvents();
      IPosModal.adModal({
        branchInfo: branchInfo,
        t: t,
        onOk: () => {},
        onClose: () => {
          // addAdvertisementEvents();
          resetTimer();
        },
      });
    }, PLAY_AD_VIDEO_TIMEOUT_SEC * 1000);
  }

  const addAdvertisementEvents = () => {
    document.addEventListener("mousemove", resetTimer);
    document.addEventListener("touchstart", resetTimer);
  };

  const removeAdvertisementEvents = () => {
    document.removeEventListener("mousemove", resetTimer);
    document.removeEventListener("touchstart", resetTimer);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await loadRestaurant(branchId);

        if (
          res &&
          res.branch_guid_code &&
          res.branch_guid_code === "i71m82f5-922d-4390-ba3e-49431746slc2"
        ) {
          const tagManagerArgs = {
            gtmId: "G-QNNETE36JG",
          };

          TagManager.initialize(tagManagerArgs);
        }

        if (res && res.error_message) {
          history.push(`/${branchId}/error`);
        }
      } catch (e) {
        history.push(`/${branchId}/error`);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (hasAdvertisement) {
      addAdvertisementEvents();
      resetTimer();
    }

    return () => {
      removeAdvertisementEvents();
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [branchInfo]);

  return (
    <div
      className={"delivery-type-layout"}
      style={{
        backgroundImage: `url(${getImageUrl(branchInfo.BannerImageName)})`,
      }}
    >
      {/* <Header/> */}
      <HeaderNew />
      <DeliveryTypeSwitcher />
      <ShortFooter />
    </div>
  );
}

const mapStateToProps = (state) => {
  const { branchInfo } = state;

  return {
    branchInfo,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      loadRestaurant,
      setLanguageId,
      setUiLanguageId,
    },
    dispatch
  );

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(DeliveryTypeLayout)
);
